import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { DecimalPipe, NgStyle } from '@angular/common'
@Component({
  selector: 'progress-bar',
  standalone: true,
  imports: [NgStyle, DecimalPipe],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
  readonly progress = input<number>(0)
  readonly type = input<string>('%')

  getTextPosition() {
    const typeLen = this.type().length
    const charOffset = typeLen * 0.25 // Offset in rem units per character

    return {
      top: '-8px',
      bottom: '0px',
      margin: 'auto',
      left:
        this.progress() < 25
          ? `calc(${this.progress()}% + 0.8rem)`
          : `calc(${this.progress()}% - ${2.1 + charOffset}rem)`
    }
  }

  getProgressColor(value: number): string {
    if (value >= 80) {
      return 'linear-gradient(270deg, #00B575 0%, #006D47 100%)'
    } else if (value >= 31) {
      return 'linear-gradient(180deg, #FFBB38 0%, #D88E00 100%)'
    } else {
      return 'linear-gradient(270deg, #8C2323 0%, #B52D2D 100%)'
    }
  }
}
